import { Controller } from "stimulus"
import client from '../../helpers/client'
import { hideTarget, showTarget } from '../../helpers/visibility'

const SPINNER_DELAY = 750

// This is based on Cocoon's format for nested fields
function buildAttachmentHtml(attachment) {
  return `
    <div class="nested-fields">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="mb-3 string optional message_attachments_display_name">
            <p>${attachment.displayName}</p>
            <input autocomplete="off" type="hidden" value="${attachment.displayName}" name="message[attachments_attributes][${attachment.index}][display_name]" id="message_attachments_attributes_${attachment.index}_display_name">
          </div>
          <div class="mb-3 url optional message_attachments_remote_attachment_url">
            <input autocomplete="off" type="hidden" value="${attachment.remoteAttachmentUrl}" name="message[attachments_attributes][${attachment.index}][remote_attachment_url]" id="message_attachments_attributes_${attachment.index}_remote_attachment_url">
          </div>
        </div>
        <div class="flex-shrink-0 ps-4">
          <input value="false" autocomplete="off" type="hidden" name="message[attachments_attributes][${attachment.index}][_destroy]" id="message_attachments_attributes_${attachment.index}__destroy">
          <a class="subtle-delete remove_fields dynamic" href="#"><i class="fa fa-times fa-2x"></i></a>
        </div>
      </div>
    </div>
  `
}




export default class extends Controller {
  static targets = [
    "automatedEventId",
    "subject",
    "emailBody",
    "smsBody",
    "recipientEmails",
    "recipientPhones",
    "delay",
    "delayWrapper",
    "submitButton",
    "from"
  ]
  static values = { args: Object }

  connect() {
    this.originalSubmitButtonText = this.submitButtonTarget.value

    this.updateVisibility()
  }

  updateVisibility() {
    const delayValue = this.delayTarget.checked
    if(delayValue) {
      showTarget(this.delayWrapperTarget)
      this.submitButtonTarget.value = "Send Later"
    }
    else {
      hideTarget(this.delayWrapperTarget)
      this.submitButtonTarget.value = this.originalSubmitButtonText
    }
  }

  renderPreview() {
    const automatedEventId = this.automatedEventIdTarget.value

    if(automatedEventId) {
      client.post(`/admin/automated_events/${automatedEventId}/rendered_preview.json`, this.argsValue)
        .then(response => {
          const { subject, messageHtml, smsBody, recipients, sender, attachments } = response.data
          console.log({ attachments })

          if(this.hasSubjectTarget) {
            this.subjectTarget.value = subject
          }

          if(this.hasSmsBodyTarget) {
            this.smsBodyTarget.value = smsBody
          }

          if(this.hasEmailBodyTarget) {
            this.emailBodyTarget.closest('.message_content.quill').querySelector(".ql-editor").innerHTML = messageHtml
          }

          if(this.hasRecipientEmailsTarget && recipients.length > 0) {
            this.recipientEmailsTarget.value = recipients.map(r => r.email).filter(email => email).join(", ")
          }

          if(this.hasRecipientPhonesTarget && recipients.length > 0) {
            this.recipientPhonesTarget.value = recipients.map(r => r.phone).filter(phone => phone).join(", ")
          }

          if(this.hasFromTarget && sender && sender.toLongForm) {
            this.fromTarget.value = sender.toLongForm
          }

          /// Add the example attachment HTML if it exists
          const attachmentContainer = this.element.querySelector("#attachment-editor")
          if(attachmentContainer) {
            const attachmentHtmlElements = attachments.map((attachment, index) => {
              return buildAttachmentHtml({
                displayName: attachment.displayName,
                remoteAttachmentUrl: attachment.remoteAttachmentUrl,
                index: index
              })
            })
            attachmentContainer.innerHTML = attachmentHtmlElements.join("")
          }

        })
        .catch(e => {
          console.warn(e.message)
          alert("An error occurred loading this template")
        })
    }
    else {
      if(this.hasSubjectTarget) {
        this.subjectTarget.value = ""
      }

      if(this.hasSmsBodyTarget) {
        this.smsBodyTarget.value = ""
      }

      if(this.hasEmailBodyTarget) {
        this.emailBodyTarget.closest('.message_content.quill').querySelector(".ql-editor").innerHTML = ""
      }
    }
  }
}
